<div class="container my-4">
	<!-- Loading spinner -->
	@if (isLoading) {
		<div
			class="d-flex justify-content-center align-items-center"
			style="min-height: 400px"
		>
			<div class="text-center">
				<div class="spinner-border text-primary" role="status">
					<span class="visually-hidden">Ladataan...</span>
				</div>
				<div class="mt-3 text-muted">Ladataan käyttäjiä...</div>
			</div>
		</div>
	} @else {
		<ul ngbNav class="nav-tabs">
			<li ngbNavItem role="presentation">
				<h3>
					<i class="bi bi-people-fill me-2 text-primary"></i>Käyttäjät
				</h3>
			</li>
			<li ngbNavItem class="ms-auto pe-2">
				<form class="form-inline">
					<div class="d-flex gap-2">
						<input
							class="form-control mr-sm-2"
							type="search"
							placeholder="Hae"
							aria-label="Hae"
							[(ngModel)]="searchText"
							name="searchText"
						/>
						<div ngbDropdown class="d-inline-block">
							<button
								class="btn btn-outline-secondary"
								id="organizationFilterDropdown"
								ngbDropdownToggle
								title="Suodata organisaation mukaan"
							>
								@if (selectedOrganizationFilter !== null) {
									{{
										getOrganizationName(
											selectedOrganizationFilter
										)
									}}
								} @else {
									Näytä kaikki
								}
							</button>
							<div
								ngbDropdownMenu
								aria-labelledby="organizationFilterDropdown"
							>
								<button
									ngbDropdownItem
									(click)="selectedOrganizationFilter = null"
									[class.active]="
										selectedOrganizationFilter === null
									"
								>
									Näytä kaikki
								</button>
								<div class="dropdown-divider"></div>
								@for (org of organizations; track org.id) {
									<button
										ngbDropdownItem
										(click)="
											selectedOrganizationFilter = org.id
										"
										[class.active]="
											selectedOrganizationFilter ===
											org.id
										"
									>
										{{ org.name }}
										<small class="text-muted"
											>({{
												org.users.length || 0
											}}
											käyttäjää)</small
										>
									</button>
								}
							</div>
						</div>
						@if (
							searchText || selectedOrganizationFilter !== null
						) {
							<button
								type="button"
								class="btn btn-outline-danger"
								title="Tyhjennä suodattimet"
								(click)="clearFilters()"
							>
								<i class="bi bi-x"></i>
							</button>
						}
					</div>
				</form>
			</li>
			<li ngbNavItem>
				<div class="col-auto d-flex gap-2">
					<button
						class="btn btn-primary"
						(click)="openAddUserModal()"
					>
						<i class="bi bi-person-plus me-1"></i>Lisää käyttäjä
					</button>
				</div>
			</li>
		</ul>

		<!-- Loading spinner -->
		<!-- <div class="row" *ngIf="isLoading">
		<div class="col-12 text-center py-5">
			<div
				class="spinner-border text-primary"
				role="status"
				style="width: 3rem; height: 3rem"
			>
				<span class="visually-hidden">Ladataan...</span>
			</div>
			<p class="mt-3">Ladataan käyttäjiä...</p>
		</div>
	</div> -->

		<!-- Error message -->
		<div class="row" *ngIf="hasError">
			<div class="col-12">
				<div class="alert alert-danger" role="alert">
					<h4 class="alert-heading">Virhe!</h4>
					<p>{{ errorMessage }}</p>
					<hr />
					<p class="mb-0">
						Yritä päivittää sivu uudelleen tai ota yhteyttä tukeen.
					</p>
				</div>
			</div>
		</div>

		<!-- No content message -->
		<div class="row" *ngIf="loginService.Users.length === 0 && !hasError">
			<div class="col-12 text-center py-5">
				<div class="alert alert-info" role="alert">
					<h4 class="alert-heading">Ei käyttäjiä</h4>
					<p>
						Järjestelmään ei ole vielä lisätty käyttäjiä. Lisää
						käyttäjä "Lisää käyttäjä" -painikkeella.
					</p>
				</div>
			</div>
		</div>

		<!-- User list -->
		<div
			class="row mt-4"
			*ngIf="loginService.Users.length > 0 && !hasError"
		>
			<div class="col-12">
				<div class="w-100 position-relative">
					<!-- No results message -->
					<div
						*ngIf="filteredUsers.length === 0 && searchText"
						class="alert alert-info text-center py-4"
					>
						Ei hakutuloksia hakusanalla "{{ searchText }}"
					</div>

					<table
						class="table table-hover"
						*ngIf="filteredUsers.length > 0"
					>
						<thead>
							<tr>
								<th
									scope="col"
									class="sortable-header"
									(click)="sortUsers('name')"
								>
									Nimi
									<i
										class="ms-1"
										[ngClass]="getSortIcon('name')"
									></i>
								</th>
								<th
									scope="col"
									class="sortable-header"
									(click)="sortUsers('userName')"
								>
									Käyttäjätunnus
									<i
										class="ms-1"
										[ngClass]="getSortIcon('userName')"
									></i>
								</th>
								<th
									scope="col"
									class="sortable-header"
									(click)="sortUsers('permission')"
								>
									Oikeudet
									<i
										class="ms-1"
										[ngClass]="getSortIcon('permission')"
									></i>
								</th>
								<!-- <th
									scope="col"
									class="sortable-header"
									(click)="sortUsers('email')"
								>
									Sähköposti
									<i
										class="ms-1"
										[ngClass]="getSortIcon('email')"
									></i>
								</th> -->
								<th
									scope="col"
									class="sortable-header"
									(click)="sortUsers('organization')"
								>
									Organisaatio
									<i
										class="ms-1"
										[ngClass]="getSortIcon('organization')"
									></i>
								</th>
								<th scope="col" class="text-end"></th>
							</tr>
						</thead>
						<tbody>
							<tr
								*ngFor="
									let user of filteredUsers;
									let i = index
								"
								[@fadeInImmediately]
								[class.table-secondary]="
									isUserBeingDeleted(user.id)
								"
							>
								<td>
									<span class="fw-medium"
										>{{ user.firstName }}
										{{ user.lastName }}</span
									>
								</td>
								<td>
									<span class="text-muted">
										{{ user.userName }}
									</span>
								</td>
								<td>
									<span class="text-muted fw-medium">
										@switch (user.permission) {
											@case (Roles.SuperAdmin) {
												<span>Pääkäyttäjä</span>
											}
											@case (Roles.Admin) {
												<span>Organisaatio</span>
											}
											@case (Roles.User) {
												<span>Käyttäjä</span>
											}
										}
									</span>
								</td>
								<!-- <td>
									<span class="text-muted">
										{{ user.email }}
									</span>
								</td> -->
								<td>
									<span class="text-muted">
										{{
											getOrganizationName(
												user.organizationId
											)
										}}
									</span>
								</td>
								<td class="text-end">
									<button
										class="btn btn-sm btn-outline-secondary me-1"
										title="Muokkaa käyttäjäasetuksia"
										(click)="openEditUserModal(user)"
										[disabled]="isUserBeingDeleted(user.id)"
									>
										<i class="bi bi-gear"></i>
									</button>
									<button
										class="btn btn-sm btn-outline-danger"
										title="Poista käyttäjä"
										(click)="openDeleteConfirmModal(user)"
										[disabled]="isUserBeingDeleted(user.id)"
									>
										<span
											*ngIf="isUserBeingDeleted(user.id)"
											class="spinner-border spinner-border-sm me-1"
											role="status"
											aria-hidden="true"
										></span>
										<i
											*ngIf="!isUserBeingDeleted(user.id)"
											class="bi bi-trash"
										></i>
									</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<!-- Add User Modal -->
		<ng-template #addUserModal let-modal>
			<div class="modal-header">
				<h4 class="modal-title">Lisää uusi käyttäjä</h4>
				<button
					type="button"
					class="btn-close"
					aria-label="Close"
					(click)="modal.dismiss('Cross click')"
					[disabled]="isAddingUser"
				></button>
			</div>
			<div class="modal-body">
				<div class="modal-spinner-overlay" *ngIf="isLoading">
					<div class="spinner-container">
						<div class="spinner-border text-primary" role="status">
							<span class="visually-hidden">Ladataan...</span>
						</div>
						<p class="mt-2 mb-0">Päivitetään käyttäjää...</p>
					</div>
				</div>
				<form>
					<div class="mb-3">
						<label for="firstName" class="form-label"
							>Etunimi</label
						>
						<input
							type="text"
							class="form-control"
							id="firstName"
							[(ngModel)]="newUser.firstName"
							name="firstName"
							required
						/>
					</div>
					<div class="mb-3">
						<label for="lastName" class="form-label"
							>Sukunimi</label
						>
						<input
							type="text"
							class="form-control"
							id="lastName"
							[(ngModel)]="newUser.lastName"
							name="lastName"
						/>
					</div>

					<div class="mb-3">
						<label for="email" class="form-label">Sähköposti</label>
						<input
							type="email"
							class="form-control"
							id="email"
							[(ngModel)]="newUser.email"
							name="email"
							required
						/>
					</div>

					<div class="mb-3">
						<div class="form-check">
							<input
								class="form-check-input"
								type="checkbox"
								id="sendEmailInvite"
								[(ngModel)]="sendEmailInvite"
								name="sendEmailInvite"
							/>
							<label
								class="form-check-label"
								for="sendEmailInvite"
							>
								Lähetä tunnukset sähköpostitse
							</label>
						</div>
						<small class="form-text text-muted">
							Kun valittu, salasana luodaan automaattisesti ja
							lähetetään käyttäjälle sähköpostitse.
						</small>
					</div>

					<div class="mb-3" *ngIf="!sendEmailInvite">
						<label for="password" class="form-label"
							>Salasana</label
						>
						<div class="input-group">
							<input
								[type]="
									showNewUserPassword ? 'text' : 'password'
								"
								class="form-control"
								id="password"
								[(ngModel)]="newUser.password"
								name="password"
								required
								[ngClass]="{
									'is-invalid':
										errors.includes(
											'PasswordRequiresNonAlphanumeric'
										) ||
										errors.includes(
											'PasswordRequiresUpper'
										) ||
										errors.includes(
											'PasswordRequiresLower'
										),
								}"
							/>
							<button
								class="btn btn-outline-secondary"
								type="button"
								title="Näytä/piilota salasana"
								(click)="toggleNewUserPasswordVisibility()"
							>
								<i
									class="bi"
									[ngClass]="
										showNewUserPassword
											? 'bi-eye-slash'
											: 'bi-eye'
									"
								></i>
							</button>
							<button
								class="btn btn-outline-secondary"
								type="button"
								title="Luo turvallinen salasana"
								(click)="generatePasswordForNewUser()"
							>
								<i class="bi bi-key"></i>
							</button>
							<button
								class="btn btn-outline-secondary"
								type="button"
								title="Kopioi salasana leikepöydälle"
								(click)="
									copyPasswordToClipboard(newUser.password)
								"
								[disabled]="!newUser.password"
							>
								<i class="bi bi-copy"></i>
							</button>
						</div>
					</div>

					<div class="mb-3">
						<label for="permission" class="form-label"
							>Käyttäjäoikeudet</label
						>
						<div ngbDropdown class="d-block">
							<button
								class="btn btn-outline-primary"
								id="permissionDropdown"
								ngbDropdownToggle
							>
								@switch (newUser.permission) {
									@case (Roles.SuperAdmin) {
										<span>Järjestelmän ylläpitäjä</span>
									}
									@case (Roles.Admin) {
										<span>Organisaation pääkäyttäjä</span>
									}
									@case (Roles.User) {
										<span>Peruskäyttäjä</span>
									}
								}
							</button>
							<div
								ngbDropdownMenu
								aria-labelledby="permissionDropdown"
							>
								<button
									*ngFor="
										let type of permissionTypes;
										let i = index
									"
									ngbDropdownItem
									(click)="newUser.permission = i"
									ngbDropdownItem
								>
									<div class="d-flex flex-column">
										@switch (i) {
											@case (Roles.SuperAdmin) {
												<span
													>Järjestelmän
													ylläpitäjä</span
												>
												<small class="text-muted">
													Voi muokata kaikkia
													käyttäjiä ja käyttää
													sovellusta.
												</small>
											}
											@case (Roles.Admin) {
												<span
													>Organisaation
													pääkäyttäjä</span
												>
												<small class="text-muted">
													Voi muokata organisaation
													käyttäjiä ja käyttää
													sovellusta.
												</small>
											}
											@case (Roles.User) {
												<span>Peruskäyttäjä</span>
												<small class="text-muted">
													Voi käyttää sovellusta.
												</small>
											}
										}
									</div>
								</button>
							</div>
						</div>
						<small class="form-text text-muted">
							Määritä käyttäjän oikeustaso järjestelmässä.
						</small>
					</div>

					<div class="mb-3">
						<label for="organization" class="form-label"
							>Organisaatio</label
						>
						<div ngbDropdown class="d-block">
							<button
								class="btn btn-outline-primary"
								id="organizationDropdown"
								ngbDropdownToggle
								[disabled]="organizations.length === 0"
							>
								<span *ngIf="organizations.length > 0">
									{{ getOrganizationName(newUser.org) }}
								</span>
								<span
									*ngIf="organizations.length === 0"
									class="text-muted"
								>
									Ei organisaatioita saatavilla
								</span>
							</button>
							<div
								ngbDropdownMenu
								aria-labelledby="organizationDropdown"
								*ngIf="organizations.length > 0"
							>
								<button
									*ngFor="let org of organizations"
									ngbDropdownItem
									(click)="newUser.org = org.id"
								>
									<div class="d-flex flex-column" *ngIf="org">
										<span>{{ org.name }}</span>
										<small
											class="text-muted"
											*ngIf="org.users"
										>
											{{ org.users.length || 0 }}
											käyttäjää
										</small>
									</div>
								</button>
							</div>
						</div>
						<small class="form-text text-muted">
							Valitse organisaatio, johon käyttäjä kuuluu.
						</small>
					</div>
				</form>

				<ngb-alert
					type="danger"
					*ngIf="errors.length > 0"
					[dismissible]="false"
				>
					<strong>Virhe</strong>
					<ul>
						<li *ngFor="let error of errors">{{ error }}</li>
					</ul>
				</ngb-alert>
			</div>
			<div class="modal-footer">
				<button
					type="button"
					class="btn btn-secondary"
					(click)="modal.close('Close click')"
					[disabled]="isAddingUser"
				>
					Peruuta
				</button>
				<button
					type="button"
					class="btn btn-primary"
					(click)="addUser()"
					[disabled]="isAddingUser"
				>
					<span
						*ngIf="isAddingUser"
						class="spinner-border spinner-border-sm me-2"
						role="status"
						aria-hidden="true"
					></span>
					{{ isAddingUser ? "Tallentaa..." : "Tallenna" }}
				</button>
			</div>
		</ng-template>

		<!-- Edit User Modal -->
		<ng-template #editUserModal let-modal>
			<div class="modal-header" *ngIf="editingUser">
				<h4 class="modal-title">Muokkaa käyttäjää</h4>
				<button
					type="button"
					class="btn-close"
					aria-label="Close"
					(click)="modal.dismiss('Cross click')"
				></button>
			</div>
			<div class="modal-body" *ngIf="editingUser">
				<div class="modal-spinner-overlay" *ngIf="isLoading">
					<div class="spinner-container">
						<div class="spinner-border text-primary" role="status">
							<span class="visually-hidden">Ladataan...</span>
						</div>
						<p class="mt-2 mb-0">Päivitetään käyttäjää...</p>
					</div>
				</div>
				<form>
					<div class="mb-3">
						<label for="editFirstName" class="form-label"
							>Etunimi</label
						>
						<input
							type="text"
							class="form-control"
							id="editFirstName"
							[(ngModel)]="editingUser.firstName"
							name="editFirstName"
							required
						/>
					</div>
					<div class="mb-3">
						<label for="editLastName" class="form-label"
							>Sukunimi</label
						>
						<input
							type="text"
							class="form-control"
							id="editLastName"
							[(ngModel)]="editingUser.lastName"
							name="editLastName"
						/>
					</div>

					<div class="mb-3">
						<label for="editEmail" class="form-label"
							>Sähköposti</label
						>
						<input
							type="email"
							class="form-control"
							id="editEmail"
							[(ngModel)]="editingUser.email"
							name="editEmail"
							required
						/>
					</div>

					<!-- Old password field - only shown for User role -->
					<div class="mb-3" *ngIf="requiresOldPassword()">
						<label for="editOldPassword" class="form-label"
							>Nykyinen salasana</label
						>
						<div class="input-group">
							<input
								[type]="
									showEditUserOldPassword
										? 'text'
										: 'password'
								"
								class="form-control"
								id="editOldPassword"
								[(ngModel)]="editingUser.oldPassword"
								name="editOldPassword"
								required
								placeholder="Anna nykyinen salasana"
							/>
							<button
								class="btn btn-outline-secondary"
								type="button"
								title="Näytä/piilota salasana"
								(click)="toggleEditUserOldPasswordVisibility()"
							>
								<i
									class="bi"
									[ngClass]="
										showEditUserOldPassword
											? 'bi-eye-slash'
											: 'bi-eye'
									"
								></i>
							</button>
						</div>
						<small class="form-text text-muted">
							Vaaditaan salasanan vaihtamiseen.
						</small>
					</div>
					<div class="mb-3">
						<label for="editPassword" class="form-label">
							<span *ngIf="requiresOldPassword()"
								>Uusi salasana</span
							>
							<span *ngIf="!requiresOldPassword()">Salasana</span>
						</label>
						<div class="input-group">
							<input
								[type]="
									showEditUserPassword ? 'text' : 'password'
								"
								class="form-control"
								id="editPassword"
								[(ngModel)]="editingUser.password"
								name="editPassword"
								placeholder="••••••••"
								[ngClass]="{
									'is-invalid':
										errors.includes(
											'PasswordRequiresNonAlphanumeric'
										) ||
										errors.includes(
											'PasswordRequiresUpper'
										) ||
										errors.includes(
											'PasswordRequiresLower'
										),
								}"
							/>
							<button
								class="btn btn-outline-secondary"
								type="button"
								title="Näytä/piilota salasana"
								(click)="toggleEditUserPasswordVisibility()"
							>
								<i
									class="bi"
									[ngClass]="
										showEditUserPassword
											? 'bi-eye-slash'
											: 'bi-eye'
									"
								></i>
							</button>
							<button
								class="btn btn-outline-secondary"
								type="button"
								title="Luo turvallinen salasana"
								(click)="generatePasswordForEditUser()"
							>
								<i class="bi bi-key"></i>
							</button>
							<button
								class="btn btn-outline-secondary"
								type="button"
								title="Kopioi salasana leikepöydälle"
								(click)="
									copyPasswordToClipboard(
										editingUser.password
									)
								"
								[disabled]="!editingUser.password"
							>
								<i class="bi bi-clipboard"></i>
							</button>
						</div>
						<small class="form-text text-muted">
							<span *ngIf="requiresOldPassword()">
								Jätä tyhjäksi, jos et halua muuttaa salasanaa.
								Nykyinen salasana vaaditaan.
							</span>
							<span *ngIf="!requiresOldPassword()">
								Jätä tyhjäksi, jos et halua muuttaa salasanaa.
							</span>
						</small>
					</div>

					<div class="mb-3">
						<label for="editPermission" class="form-label"
							>Käyttäjäoikeudet</label
						>

						@let currentUser = loginService.GetCurrentUser();

						<div ngbDropdown class="d-inline-block ms-2">
							<button
								class="btn btn-outline-secondary dropdown-toggle w-100"
								type="button"
								id="editPermission"
								ngbDropdownToggle
							>
								{{ getRoleDisplayName(editingUser.permission) }}
							</button>
							<div
								ngbDropdownMenu
								aria-labelledby="editPermission"
							>
								@for (
									permissionType of permissionTypes;
									track permissionType;
									let i = $index
								) {
									<button
										ngbDropdownItem
										type="button"
										(click)="editingUser.permission = i"
										[disabled]="
											!!(
												currentUser &&
												currentUser.permission < i
											)
										"
									>
										{{ getRoleDisplayName(permissionType) }}
									</button>
								}
							</div>
						</div>
						<small class="form-text text-muted d-block">
							Määritä käyttäjän oikeustaso järjestelmässä.
						</small>
					</div>
				</form>

				@if (errors.length > 0) {
					<ngb-alert type="danger" [dismissible]="false">
						<strong>Virhe</strong>
						<ul>
							@for (error of errors; track error) {
								<li>{{ error }}</li>
							}
						</ul>
					</ngb-alert>
				}
			</div>
			@if (editingUser) {
				<div class="modal-footer">
					<button
						type="button"
						class="btn btn-secondary"
						(click)="modal.close('Close click')"
					>
						Peruuta
					</button>
					<button
						type="button"
						class="btn btn-primary"
						(click)="updateUser()"
						[disabled]="isUpdatingUser"
					>
						@if (isUpdatingUser) {
							<span
								class="spinner-border spinner-border-sm me-2"
								role="status"
								aria-hidden="true"
							></span>
						}
						{{
							isUpdatingUser
								? "Tallentaa..."
								: "Tallenna muutokset"
						}}
					</button>
				</div>
			}
		</ng-template>

		<!-- Delete Confirmation Modal -->
		<ng-template #deleteConfirmModal let-modal>
			<div class="modal-header">
				<h5 class="modal-title">Vahvista poisto</h5>
				<button
					type="button"
					class="btn-close"
					aria-label="Close"
					(click)="modal.dismiss()"
				></button>
			</div>
			<div class="modal-body">
				<p *ngIf="userToDelete">
					Haluatko varmasti poistaa käyttäjän
					<strong
						>{{ userToDelete.firstName }}
						{{ userToDelete.lastName }}</strong
					>?
				</p>
				<p class="text-muted mb-0">Tätä toimintoa ei voi peruuttaa.</p>
			</div>
			<div class="modal-footer">
				<button
					type="button"
					class="btn btn-secondary"
					(click)="modal.dismiss()"
				>
					Peruuta
				</button>
				<button
					type="button"
					class="btn btn-danger"
					(click)="modal.close('confirm')"
				>
					Poista
				</button>
			</div>
		</ng-template>
	}
</div>
